/* CHQ Compare Bar v1 — manages multi-select compare state across collection page navigation */
(function(){
  if (window.__chqCompare) return;
  window.__chqCompare = true;

  var STORAGE_KEY = 'chq_compare_v1';
  var MAX_ITEMS = 4;

  function load() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch(e) { return []; }
  }
  function save(items) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch(e) {}
  }

  function ensureBar() {
    var bar = document.querySelector('.chq-compare-bar');
    if (bar) return bar;
    bar = document.createElement('div');
    bar.className = 'chq-compare-bar';
    bar.innerHTML = '<div class="chq-compare-bar__items"></div>' +
      '<div class="chq-compare-bar__actions">' +
        '<button class="chq-compare-bar__clear" type="button">Clear</button>' +
        '<a class="chq-compare-bar__btn" href="#">Compare →</a>' +
      '</div>';
    document.body.appendChild(bar);
    bar.querySelector('.chq-compare-bar__clear').addEventListener('click', function(){
      save([]);
      document.querySelectorAll('.chq-compare-checkbox').forEach(function(cb){ cb.checked = false; });
      render();
    });
    return bar;
  }

  function render() {
    var items = load();
    var bar = ensureBar();
    var itemsEl = bar.querySelector('.chq-compare-bar__items');
    var btn = bar.querySelector('.chq-compare-bar__btn');
    if (items.length < 2) {
      bar.classList.remove('is-visible');
      return;
    }
    itemsEl.innerHTML = items.map(function(item){
      return '<span class="chq-compare-bar__chip">' +
        (item.image ? '<img class="chq-compare-bar__chip-img" src="' + item.image + '" alt="">' : '') +
        '<span class="chq-compare-bar__chip-title">' + item.title + '</span>' +
        '<span class="chq-compare-bar__chip-x" data-id="' + item.id + '">×</span>' +
      '</span>';
    }).join('');
    var ids = items.map(function(i){ return i.handle; }).join(',');
    btn.href = '/pages/compare?ids=' + encodeURIComponent(ids);
    btn.textContent = 'Compare ' + items.length + ' →';
    bar.classList.add('is-visible');

    itemsEl.querySelectorAll('.chq-compare-bar__chip-x').forEach(function(x){
      x.addEventListener('click', function(){
        var id = String(this.dataset.id);
        var current = load().filter(function(i){ return String(i.id) !== id; });
        save(current);
        var cb = document.querySelector('.chq-compare-checkbox[data-product-id="' + id + '"]');
        if (cb) cb.checked = false;
        render();
      });
    });
  }

  function syncCheckboxes() {
    var items = load();
    var ids = items.map(function(i){ return String(i.id); });
    document.querySelectorAll('.chq-compare-checkbox').forEach(function(cb){
      cb.checked = ids.indexOf(String(cb.dataset.productId)) !== -1;
    });
  }

  function bind() {
    document.addEventListener('change', function(e){
      if (!e.target.classList || !e.target.classList.contains('chq-compare-checkbox')) return;
      var cb = e.target;
      var items = load();
      var id = String(cb.dataset.productId);
      var existing = items.find(function(i){ return String(i.id) === id; });
      if (cb.checked) {
        if (existing) return;
        if (items.length >= MAX_ITEMS) {
          cb.checked = false;
          alert('You can compare up to ' + MAX_ITEMS + ' products at a time.');
          return;
        }
        items.push({
          id: cb.dataset.productId,
          handle: cb.dataset.productHandle,
          title: cb.dataset.productTitle,
          url: cb.dataset.productUrl,
          image: cb.dataset.productImage
        });
      } else {
        items = items.filter(function(i){ return String(i.id) !== id; });
      }
      save(items);
      render();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      bind(); syncCheckboxes(); render();
    });
  } else {
    bind(); syncCheckboxes(); render();
  }
})();
